"use client";

import { memo } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

export const ScrollMouseIcon = memo(function ScrollMouseIcon() {
  const isMobile = useIsMobile();
  
  // Hide on mobile for performance
  if (isMobile) return null;
  
  return (
    <div 
      className="absolute bottom-8 left-0 right-0 flex justify-center animate-fade-in"
      style={{ animationDelay: '1s', animationFillMode: 'both' }}
    >
      <div className="gap-2 items-center justify-center flex flex-col mx-0">
        {/* Mouse outline with CSS pulse animation */}
        <div className="relative">
          {/* Pulse ring - CSS only */}
          <div 
            className="absolute inset-0 rounded-full border-2 border-primary/30 animate-pulse-ring"
            style={{ width: 24, height: 40 }}
          />
          <div className="relative w-6 h-10 rounded-full border-2 border-muted-foreground/40">
            {/* Scroll wheel - CSS animation */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-1 h-2 bg-primary rounded-full animate-scroll-wheel" />
          </div>
        </div>
        <span className="text-xs text-muted-foreground/60 uppercase tracking-widest">
          Scroll
        </span>
      </div>
    </div>
  );
});